import React, { useMemo } from 'react';
import { linkifyText } from '../../libs/utils/linkifyText';
import { withReferralParams } from '../../libs/utils/referralTracking';

export interface LinkifiedLinkProps {
    href: string;
    target: string;
    rel: string;
    children: string;
}

interface LinkifiedTextProps {
    text: string;
    // Fluent's Link in the customer chat; a plain <a> in the agent workspace, which has its own CSS and no
    // Fluent theme.
    linkAs: React.ElementType<LinkifiedLinkProps>;
}

// A support agent's message, in the customer chat and in the agent's own thread (#2826). Both get the same
// href, so a link the agent tries out is the one the customer opens.
export const LinkifiedText: React.FC<LinkifiedTextProps> = ({ text, linkAs: Link }) => {
    const segments = useMemo(() => linkifyText(text), [text]);

    return (
        <>
            {segments.map((segment, index) =>
                segment.kind === 'link' ? (
                    <Link
                        key={index}
                        href={withReferralParams(segment.href, 'support-link')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {segment.text}
                    </Link>
                ) : (
                    <React.Fragment key={index}>{segment.text}</React.Fragment>
                ),
            )}
        </>
    );
};
